__turbopack_context__.v({
  "h2": "v0eWvq_h2",
  "h2Large": "v0eWvq_h2Large",
  "h3": "v0eWvq_h3",
  "p": "v0eWvq_p",
  "productSectionPadding": "v0eWvq_productSectionPadding",
  "sectionPadding": "v0eWvq_sectionPadding",
});
